var devisNewProductBo = {
    categorieProduitId: 0,
    contenu: []
};

export default devisNewProductBo;


// WEBPACK FOOTER //
// ./src/components/data/devis/DevisNewProduct.js